export const sectionOrder = ['overview', 'introduction', 'experiment', 'tutorial', 'exercises'];

export function orderedSections(content = {}) {
  const entries = Object.entries(content);
  return [...entries].sort(([first], [second]) => {
    const firstIndex = sectionOrder.indexOf(first);
    const secondIndex = sectionOrder.indexOf(second);
    if (firstIndex === -1 && secondIndex === -1) return 0;
    if (firstIndex === -1) return 1;
    if (secondIndex === -1) return -1;
    return firstIndex - secondIndex;
  });
}

const meaningful = value => value && value !== 'NOTAB' && value !== 'NOSTEP';

export function normalizeWorksheetTopics(data, section) {
  const tabs = data?.tabs || [];
  const hasNamedTabs = tabs.some(tab => meaningful(tab.name));

  if (hasNamedTabs) {
    return tabs.map((tab, tabIndex) => ({
      id: `${section}-topic-${tabIndex}`,
      label: meaningful(tab.name) ? tab.name : data.name,
      steps: tab.steps || [],
      topicOwnsSteps: false,
    }));
  }

  const steps = tabs.flatMap(tab => tab.steps || []);
  const namedSteps = steps.filter(step => meaningful(step.name));
  if (namedSteps.length >= 2) {
    return steps.map((step, stepIndex) => ({
      id: `${section}-topic-${stepIndex}`,
      label: meaningful(step.name) ? step.name : `${data.name} part ${stepIndex + 1}`,
      steps: [step],
      topicOwnsSteps: true,
    }));
  }

  return [{
    id: `${section}-topic-0`,
    label: data?.name || section,
    steps,
    topicOwnsSteps: true,
  }];
}

export function normalizeExerciseTopics(data) {
  return (data?.problemSets || []).map((problemSet, index) => ({
    id: `exercises-topic-${index}`,
    label: problemSet.name,
    problemSet,
  }));
}

export function normalizedHeading(value = '') {
  return value
    .replace(/<[^>]*>/g, ' ')
    .replace(/&[a-z0-9#]+;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleLowerCase();
}
